import React from 'react';
import LoomAdModal from './view';

type Props = {
	isModalOpen: boolean;
	onModalClose: () => void;
};

const LoomAdModalContainer = ({ isModalOpen, onModalClose }: Props) => (
	<LoomAdModal isModalOpen={isModalOpen} onClose={onModalClose} />
);

export default LoomAdModalContainer;
